// locationService.js
import { locationAPI } from './restaurantAPI';

const locationService = {
  // Get all locations
  async getAll(params = {}) {
    try {
      const response = await locationAPI.getAll(params);
      console.log('Location API Response:', response);
      return response.data;
    } catch (error) {
      console.error('Error in locationService.getAll:', error);
      throw error;
    }
  },

  // Get single location
  async get(id) {
    try {
      const response = await locationAPI.getById(id);
      return response.data;
    } catch (error) {
      console.error('Error in locationService.get:', error);
      throw error;
    }
  },

  // Create new location (check-in)
  async create(data) {
    try {
      console.log('Creating location with data:', data);
      const response = await locationAPI.create(data);
      return response.data;
    } catch (error) {
      console.error('Error in locationService.create:', error);
      throw error;
    }
  },

  // Update location
  async update(id, data) {
    try {
      const response = await locationAPI.update(id, data);
      return response.data;
    } catch (error) {
      console.error('Error in locationService.update:', error);
      throw error;
    }
  },

  // Checkout (check-out)
  async checkout(id, data) {
    try {
      console.log('Checking out location:', id, data);
      const response = await locationAPI.checkOut(id, data);
      return response.data;
    } catch (error) {
      console.error('Error in locationService.checkout:', error);
      throw error;
    }
  },

  // Cancel location
  async cancel(id) {
    try {
      // Note: Votre API ne semble pas avoir d'endpoint spécifique pour annuler
      // On peut utiliser update avec statut='annulee'
      const response = await locationAPI.update(id, { statut: 'annulee' });
      return response.data;
    } catch (error) {
      console.error('Error in locationService.cancel:', error);
      throw error;
    }
  },

  // Add service to location
  async addService(id, data) {
    try {
      const response = await locationAPI.addService(id, data);
      return response.data;
    } catch (error) {
      console.error('Error in locationService.addService:', error);
      throw error;
    }
  },

  // Get active locations
  async getActive() {
    try {
      const response = await locationAPI.getActive();
      return response.data;
    } catch (error) {
      console.error('Error in locationService.getActive:', error);
      throw error;
    }
  },

  // Get location statistics
  async getStats(params = {}) {
    try {
      const response = await locationAPI.getAll(params);
      const locations = response.data;
      
      // Calculer les statistiques manuellement
      const stats = {
        total: locations.length,
        en_cours: locations.filter(l => l.statut === 'en_cours').length,
        terminees: locations.filter(l => l.statut === 'terminee').length,
        annulees: locations.filter(l => l.statut === 'annulee').length,
        revenu_total: locations
          .filter(l => l.statut === 'terminee')
          .reduce((sum, l) => sum + (parseFloat(l.montant_total) || 0), 0),
        revenu_attendu: locations
          .filter(l => l.statut === 'en_cours')
          .reduce((sum, l) => sum + (parseFloat(l.prix_convenu) || 0), 0)
      };
      
      return stats;
    } catch (error) {
      console.error('Error in locationService.getStats:', error);
      throw error;
    }
  }
};

export default locationService;